import { render, staticRenderFns } from "./v_award.vue?vue&type=template&id=65fdb6c0&scoped=true"
import script from "./v_award.vue?vue&type=script&lang=js"
export * from "./v_award.vue?vue&type=script&lang=js"
import style0 from "./v_award.vue?vue&type=style&index=0&id=65fdb6c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdb6c0",
  null
  
)

export default component.exports